import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import SalesOrderSearchFormLayout from '../salesOrdersTab/SalesOrderSearchFormLayout';
import {
    GetLookupData, GetSalesOrderGridData, GetOrderDetailGridData, GetArOpenItemGridData
    , GetItemMasterGridData
} from "../../../../services/SalesOrderService";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const EdiWebFilters = (props) => {
    const orderStatus = '2';
    const orderDetailTab = 1;
    const getProfileUrl = "om/SaleOrder/GetProfiles";
    const getCustomerUrl = "om/SaleOrder/GetCustomers";
    const [selectedItems, setSelectedItems] = useState([]);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const [activeTab, setActiveTab] = useState(orderDetailTab);
    const [forceRender, setForceRender] = useState(false);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        ShippingDateFrom: '',
        ShippingDateTo: '',
        OrderDateFrom: '',
        OrderDateTo: '',
        R_PROFILE: '',
        R_CUSTOMER: '',
        TRANSACTIONNUMBER: '',
        PURCHASEORDERNUMBER: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);

    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );
    const handleFormSubmit = (e) => {
        props.searchData(formFields);
    };
    const handleFieldChange = useCallback((name, value) => {

        console.log(name, value)

    }, []);
    const handleReset = () => {
        setformFields(initialFormFields);
    };
    const formRefs = useRef({});
    const handleSalesOrderSearchFormLoad = useCallback(() => {
        GetLookupData("R_PROFILE", getProfileUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
        GetLookupData("R_CUSTOMER", getCustomerUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
    }, []);

    return (
            <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                        selectionChanged(e, e.target);
                    }
                }}
                itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2
                                    }}
                                >
                                    Sales Order Management - (EDI/WEB)
                                </h6>
                            </div>
                        </Item>

                        <Item location="after">
                            <Button className="accordianButton" onClick={handleFormSubmit} text="Search" type="default" />
                        </Item>
                        <Item location="after">
                            <Button className="accordianButton" onClick={handleReset} text="Reset" />
                        </Item>
                    </Toolbar>
                )}
                itemRender={() => (
                    <div >
                        <FormField
                            currrentUser={currentUser}
                            layoutId='3FECE58E-1EF1-4FC3-BC5A-01732B1D0A4B'
                            layoutName='MyTestForm'
                            defaultFormSchema={SalesOrderSearchFormLayout}
                            formFields={formFields}
                            setformFields={setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleSalesOrderSearchFormLoad}
                            noSpacingBeforeFirstRow={true}
                        />

                    </div>
                )}
                id="accordion-container" className="accordion-height"
            />
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(EdiWebFilters);